import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Loading from './loading';

export default class Pagination extends React.Component {
  static propTypes = {
    page: PropTypes.number.isRequired,
    totalPageCount: PropTypes.number.isRequired,
    pageUrl: PropTypes.string.isRequired,
  };

  get first() {
    const n = this.props.page >= 10 ? 3 : 10;
    return Math.min(this.props.totalPageCount, n);
  }

  get second() {
    const { page, totalPageCount } = this.props;
    return (page >= 10 && totalPageCount >= 12 && page <= totalPageCount - 9) ? 7 : 0;
  }

  get third() {
    const { page, totalPageCount } = this.props;
    let n;
    if (totalPageCount <= 12) {
      n = 0;
    } else {
      n = (page >= totalPageCount - 8) ? 10 : 3;
    }
    return n;
  }

  render() {
    const { page, totalPageCount, pageUrl } = this.props;
    const getPageLink = p => (
      <li key={`page-link-${p}`}>
        {p === page ? p : (<a href={`${pageUrl}?p=${p}`}>{p}</a>)}
      </li>
    );

    return (
      <nav className="pagination">
        <Loading variant="inline" ref={x => (this.spinner = x)}>
          <ul>
            {page !== 1 && (<li><a href={`${pageUrl}?p=${page - 1}`}>&lt; Back</a></li>)}
            {page === 1 && (<li>&lt; Back</li>)}
            {_.range(this.first).map(n => n + 1).map(getPageLink)}
            {!!this.second && (<li>&hellip;</li>)}
            {_.range(this.second).map(n => page - 3 + n).map(getPageLink)}
            {!!this.third && (<li>&hellip;</li>)}
            {_.range(this.third)
              .map(n => totalPageCount - this.third + n + 1)
              .map(getPageLink)}
            {page !== totalPageCount && (<li><a href={`${pageUrl}?p=${page + 1}`}>Next &gt;</a></li>)}
            {page === totalPageCount && (<li>Next &gt;</li>)}
          </ul>
        </Loading>
      </nav>
    );
  }
}
